import type { ConnectorAuthMethod, ConnectorAuthSchema } from "@/lib/api";

function castAuthSchema(
  raw?: Record<string, unknown> | null
): ConnectorAuthSchema | undefined {
  if (!raw) return undefined;
  return raw as unknown as ConnectorAuthSchema;
}

export function getAuthMethods(
  raw?: Record<string, unknown> | null
): ConnectorAuthMethod[] {
  return castAuthSchema(raw)?.methods ?? [];
}
